"use client";

import { useState } from "react";

import EyeIcon from "@/icons/eye.svg";
import EyeSlashIcon from "@/icons/eye-slash.svg";

import { IconSwitchButton } from "@/shared-ui/SwitchButton";
import { AppField } from "@/dls/AppField";

type PasswordFieldNewProps = React.ComponentProps<typeof AppField>;

const PasswordFieldNew: React.FC<PasswordFieldNewProps> = (props) => {
  const [isVisible, setIsVisible] = useState(false);

  const suffix = (
    <IconSwitchButton
      iconSize={20}
      tabIndex={-1}
      checked={isVisible}
      CheckedIcon={EyeIcon}
      UncheckedIcon={EyeSlashIcon}
      onCheckedChange={() => setIsVisible((prev) => !prev)}
    />
  );

  return (
    <AppField
      type={isVisible ? "text" : "password"}
      suffix={suffix}
      {...props}
    />
  );
};

export { PasswordFieldNew };
